
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wp4s_eurf9_181",
  "file-input": "awsui_file-input_1wp4s_eurf9_185",
  "file-input-button": "awsui_file-input-button_1wp4s_eurf9_200",
  "force-focus-outline-icon": "awsui_force-focus-outline-icon_1wp4s_eurf9_200",
  "force-focus-outline-button": "awsui_force-focus-outline-button_1wp4s_eurf9_221"
};
  